import React from 'react';
import { Paper, Box, Typography, Card, CardContent } from '@mui/material';
import { colors, fonts, spacing, borderRadius, shadows } from '../../constants';

/**
 * StatusDistributionCards Component
 * Status distribution cards component
 */
const StatusDistributionCards = ({ statusDistribution }) => {
  return (
    <Box sx={{ flex: '1 1 50%', width: { xs: '100%', md: '50%' }, minWidth: 0 }}>
      <Paper sx={{ p: spacing.xs, borderRadius: borderRadius.md, boxShadow: shadows.md, width: '100%', height: '100%' }}>
        <Typography variant="h6" sx={{ fontWeight: fonts.weightBold, mb: spacing.xs, fontSize: fonts.fontSizeSm }}>
          Query Status Distribution
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: spacing.xs, width: '100%', alignItems: 'stretch', height: 180 }}>
          {statusDistribution.map((status, index) => (
            <Card
              key={index}
              sx={{
                borderRadius: borderRadius.sm,
                boxShadow: shadows.sm,
                flex: '1 1 0',
                minWidth: 0,
                width: '33.33%',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                background: `linear-gradient(135deg, ${status.color}15 0%, ${status.color}08 100%)`,
                border: `1.5px solid ${status.color}30`,
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: `0 4px 12px ${status.color}30, ${shadows.md}`,
                  borderColor: `${status.color}60`,
                },
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '3px',
                  background: status.color,
                  zIndex: 1,
                },
              }}
            >
              <CardContent
                sx={{
                  p: spacing.sm,
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  position: 'relative',
                  zIndex: 0,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: colors.textSecondary,
                    mb: spacing.xs,
                    fontSize: fonts.fontSizeXs,
                    fontWeight: fonts.weightMedium,
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  }}
                >
                  {status.name}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: fonts.weightBold,
                    fontSize: '1.75rem',
                    color: status.color,
                    mb: spacing.xs,
                    lineHeight: 1.2,
                  }}
                >
                  {status.percentage}%
                </Typography>
                <Box
                  sx={{
                    width: '60%',
                    height: '3px',
                    backgroundColor: `${status.color}20`,
                    borderRadius: borderRadius.sm,
                    mt: spacing.xs,
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      width: `${status.percentage}%`,
                      height: '100%',
                      backgroundColor: status.color,
                      borderRadius: borderRadius.sm,
                      transition: 'width 0.5s ease',
                    }}
                  />
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default StatusDistributionCards;
